"use client";

import { useEffect } from "react";
import { isProd } from "@/utils/environments";
import { datadogLogs } from "@datadog/browser-logs";
import { useStatisticsConsent } from "@/legal/cookie-consent/useCookiebotConsent";

type DatadogInitProps = {
  allowedTracingUrls: string[];
  version: string;
};

export default function DatadogClient({
  allowedTracingUrls,
  version,
}: DatadogInitProps) {
  useEffect(() => {
    datadogLogs.init({
      clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN ?? "",
      site: "datadoghq.eu",
      service: "netthandel",
      forwardErrorsToLogs: true,
      env: isProd() ? "production" : "preview",
      trackingConsent: isProd() ? "not-granted" : "granted",
      version,
    });
  }, [allowedTracingUrls]);

  useStatisticsConsent((granted) => {
    const consent = granted ? "granted" : "not-granted";
    datadogLogs.setTrackingConsent(consent);
    datadogLogs.logger.log(
      `Updated Datadog tracking consent to: ${granted ? "granted" : "not-granted"}`,
      {
        statisticsConsent: granted,
      },
    );
  });

  return null;
}
